<template>
  <div class="trainer-standoff trastadff">
    <div class="trastadff_content">
      <span
        v-show="hasSkeleton && !textHtml"
        class="trastadff_skeleton"
      ></span>
      <span
        v-show="textHtml"
        class="trastadff_title truncate my-auto"
        style="max-width: clamp(1px, 24rem, calc(100vw - 8rem))"
        v-html="textHtml"
      >
      </span>
      <GwMenu
        v-if="textHtml"
        ref="gwmenu"
        placement="right"
        :isInside="false"
        :zIndexContent="11"
      >
        <template #opener>
          <div
            class="mdi icon_btn mdi-information-outline my-auto"
            style="padding: 0.25rem"
          ></div>
        </template>
        <template #default="{ methods }">
          <CustomSolutionDetail
            v-if="isCustomSolution"
            style="--clr-back: var(--clr-black-1-1)"
            class="gw_menu"
            data-gwmenu="noclose"
            endpoint="poker/custom-solutions/custom-trees/"
            :detailId="customTree.id"
            @close="methods.toggleOpen(false)"
            @loaded="
              () => {
                if ($refs.gwmenu) {
                  $refs.gwmenu.toggleOpen(true)
                }
              }
            "
          />
          <GameFormatOptionVertical
            v-else
            :gameformat="gameformat"
            :hasChangeBtn="false"
            class="gw_menu no-events"
            style="
              padding: 0.25rem;
              --clr-card-back: var(--clr-black-2);
              background-color: var(--clr-card-back);
              --size-title: 0.875em;
              --size-item: 0.875em;
              --height: auto;
              color: var(--clr-white-0);
            "
          />
        </template>
      </GwMenu>
      <!-- </span> -->
      <slot />
    </div>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import { getCustomTreeNameConf } from '@/store/gameformat/gameformat'

import GameFormatOptionVertical from '@/components/GameFormat/GameFormatOptionVertical'
import CustomSolutionDetail from '@/components/DataTables/v2/tables/CustomSolutionsHistoryList/CustomSolutionDetail'
// import GwMenu from '@/components/lib/GwMenu'

import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TrainerStandoff',
  components: {
    GameFormatOptionVertical,
    CustomSolutionDetail,
    // GwMenu,
    GwMenu,
  },
  mixins: [format_mix, float_mix],
  props: {
    queryStandoff: Object,
    hasSkeleton: Boolean,
    gameformat: Object,
    customTree: Object,
    onlyDepth: Boolean,
  },

  computed: {
    isCustomSolution() {
      return this.customTree && this.queryStandoff.solution_type === 'custom'
    },
    textHtml() {
      if (this.isCustomSolution) {
        const { players, depth } = getCustomTreeNameConf({
          customTree: this.customTree,
        })
        let res = Object.values({ players, depth }).filter(i => i)
        res = res.join(' • ')
        return res
      }

      const tp = this.gameformat?.tournament_phase
      const qse = {
        fh_hero_tmp: this.queryStandoff?.fh_hero_tmp || '',
        fh_action_tmp: this.queryStandoff?.fh_action_tmp || '',
        fh_opponent_tmp: this.queryStandoff?.fh_opponent_tmp?.split(',').filter(i => i) || [],
        depth: Number(this.queryStandoff?.depth || 0),
      }

      const avg_stack =
        this.gameformat?.gm_type === 'mtt' && this.gameformat?.format === 'icm'
          ? `${this.gameformat?.avg_stack}bb`
          : undefined

      const depth = `${this.numRoundTo5bb(qse.depth, 'bb')}bb`
      if (this.onlyDepth && qse.depth) {
        return depth
      }

      const hero = this.getPlayerHtmlPosition(qse.fh_hero_tmp)
      if (hero) {
        const opponent =
          qse.fh_opponent_tmp.length === 1 ? this.getPlayerHtmlPosition(qse.fh_opponent_tmp[0]) : ''
        const vs = opponent ? this.$t('common.versus_short') : ''
        const action = qse.fh_action_tmp ? this.$t(`shortcut.${qse.fh_action_tmp}`) : ''
        const players = [hero, vs, opponent].filter(i => i).join(' ')
        const tournament_phase = tp ? this.$t(`gametypes.${tp}_players`) : ''

        const res = [players, action, avg_stack || depth, tournament_phase]
          .filter(i => i)
          .join(', ')
        return res
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.trastadff {
  display: flex;
  --size: 1em;
  --weight: 700;
  --justify-content: flex-start;
  // --letter-spacing: auto;
  // position: relative;
  --letter-spacing: 0.5px;
  &_content {
    display: flex;
    align-items: center;
    justify-content: var(--justify-content);
    position: relative;
    height: 1.5em;
    width: 100%;
    max-width: clamp(1px, 24rem, calc(100vw - 12rem));
  }
  &_title {
    font-size: var(--size);
    font-weight: var(--weight);
    letter-spacing: var(--letter-spacing);
  }
  &_skeleton {
    position: absolute;
    background: var(--clr-black-2);
    border-radius: 4px;
    width: 8em;
    height: 1.5em;
  }
}
</style>
